const defaultState = {};

const mutations = {
    setComponentTypeState(state, componentType) {
        Object.assign(state, componentType);
    },
    resetComponentTypeState(state) {
        Object.keys(state).forEach(key => {
            delete state[key];
        });
    },
};

const actions = {
    async getComponentTypeInfo({ commit, dispatch }, componentTypeId) {
        try {
            const { data } = await this.$rq.getComponentTypes();
            const componentType = data.componentTypes.find(type => type.id === componentTypeId);
            commit('setComponentTypeState', componentType);
        } catch (err) {
            dispatch('resetComponentTypeInfo');
        }
    },
    resetComponentTypeInfo({ commit }) {
        commit('resetComponentTypeState');
    },
};

const getters = {
    componentType: state => state,
};

const state = { ...defaultState };

export default {
    state,
    getters,
    actions,
    mutations,
};
